import { mdiAccountCircleOutline } from '@mdi/js';
import i18n from '@/i18n';
import Contact from '@/pages/contact/Contact';

export default [
  {
    meta: {
      title: i18n.global.t('page_titles.contact'),
      requiresAuth: false,
    },
    path: '/contact',
    name: 'contact',
    component: Contact,
  },
  {
    meta: {
      title: i18n.global.t('page_titles.contact'),
      requiresAuth: true,
    },
    path: '/contact-auth',
    name: 'contact-auth',
    component: Contact,
  },
  {
    meta: {
      title: i18n.global.t('page_titles.about'),
      requiresAuth: false,
    },
    path: '/about',
    name: 'about',
    component: () => import('@/pages/about/About.vue'),
  },
  {
    path: '/about-auth',
    redirect: '/about',
  },
  {
    meta: {
      title: i18n.global.t('page_titles.privacy_policy'),
      requiresAuth: false,
    },
    path: '/privacy-statement',
    name: 'privacy-statement',
    component: () => import('@/pages/privacy-statement/PrivacyStatement'),
  },
  {
    meta: {
      title: i18n.global.t('page_titles.privacy_policy'),
      requiresAuth: true,
    },
    path: '/privacy-statement-auth',
    name: 'privacy-statement-auth',
    component: () => import('@/pages/privacy-statement/PrivacyStatement'),
  },
  {
    meta: {
      title: 'Shared Dashboard',
      formScreen: true,
      requiresAuth: false,
      hideNewsletter: true,
      hideFooter: true,
    },
    path: '/s/:token',
    name: 'shared-dashboard',
    component: () =>
      import('../../features/custom-dashboards/pages/SharedDashboardAccess.vue'),
  },
  {
    meta: {
      title: i18n.global.t('page_titles.error'),
      formScreen: true,
    },
    path: '/error',
    name: 'error',
    component: () => import('@/pages/error/Error'),
  },
  {
    // Login stuff
    meta: {
      cauldron: 'platform',
      title: i18n.global.t('page_titles.profile'),
      icon: mdiAccountCircleOutline,
      requiresAuth: true,
      hideNewsletter: true,
      hideFooter: true,
      favoritable: false,
      breadcrumbs: [
        { label: i18n.global.t('cauldron.platform.label'), to: '/profile' },
        { label: i18n.global.t('page_titles.profile'), to: '/profile' },
      ],
    },
    path: '/profile',
    name: 'profile',
    component: () => import('@/pages/account/Profile'),
  },
];
